export const COMET_APPID = process.env.REACT_APP_COMETCHAT_APP_ID || '';
export const COMET_REGION = process.env.REACT_APP_COMETCHAT_APPREGION || '';
export const COMET_ID = process.env.REACT_APP_COMETCHAT_AUTHKEY || '';
export const COMET_UI_LAUNCHER = 'CometChatUiLauncher.js';
export const COMET_LOAD_DELAY = 1000;
export const COMET_CLOUD_USER_ID = '01234567890123456789012345678901';
export const COMET_USERID_LENGTH = 32;
export const MINIMUM_INSTRUCTOR_NAME_LENGTH = 5;
